import * as angular from 'angular';
import { CkiAncillariesUtilsService } from '@pages/ib-web-ancillaries/services/ib-ckeckin-ancillaries-utils';

export class AncGetCachedInformationService {

    constructor (
        private CheckinAncillariesConstants: CheckinAncillariesConstants,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private CkiAncillariesUtilsService: CkiAncillariesUtilsService,
        private CommonsNewHttpUtilsErrorService: CommonsNewHttpUtilsErrorService,
        private CommonsGenericProxy: CommonsGenericProxy
    ) {}

    getCachedInformation = () => {
        const checkinId = this.localStorageService.get('flowId');
        let endpoint = this.CkiAncillariesUtilsService.getEndpoint('pac-prm-rs');
        endpoint = endpoint ? endpoint + this.CheckinAncillariesConstants.cachedInformationURI : this.CheckinAncillariesConstants.DEFAULT_ENDPOINTS.cachedInformationURI;
        const uri = endpoint + checkinId + '/cached';
        return new Promise((resolve, reject) => {
            if (checkinId !== null)  {
                this.CommonsGenericProxy.getGeneric(endpoint).then(
                    (data)=> {
                        resolve(data.data);
                    },
                    (error) => {
                        this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
                    });
            }
        });
    };
}
AncGetCachedInformationService.$inject = ['CheckinAncillariesConstants', 'localStorageService', 'CkiAncillariesUtilsService', 'CommonsNewHttpUtilsErrorService', 'CommonsGenericProxy'];
try {
    const mod = angular.module('ib-checkin-ancillaries-module');
    mod.service(
        'AncGetCachedInformationService',
        AncGetCachedInformationService
    );
} catch (error) {
    const mod = angular.module('ib-checkin-ancillaries-module', []);
    mod.service(
        'AncGetCachedInformationService',
        AncGetCachedInformationService
    );
}
